export default "__VITE_ASSET__gtqD4k2e__"